/* eslint-disable react/button-has-type */
import React from 'react';
import Icon from '../Icon/Icon';

type ButtonProps = {
  label: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
};

function Button({ label, type, className, disabled, loading, onClick, ...props }: ButtonProps) {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      className={`py-[15px] px-[20px] text-sm rounded-full bg-river-blue 
      justify-center text-white inline-flex items-center hover:bg-river-light-blue cursor-pointer 
      transition-all ease-linear ${
        loading ? 'disabled:cursor-wait' : 'disabled:cursor-not-allowed'
      }  disabled:text-gray-300/60 disabled:bg-river-blue/80 disabled:border-transparent
        ${className}`}
    >
      {!(disabled && loading) ? label : 'Please wait...'}

      {disabled && loading && <Icon id="loader" className="w-5 h-5 ml-2" />}
    </button>
  );
}

Button.defaultProps = {
  className: '',
  type: 'button',
  disabled: false,
  loading: false,
};

export default Button;
